import { render, staticRenderFns } from "./exibir-recurso-acessibilidade.vue?vue&type=template&id=02d53b8a&"
import script from "./exibir-recurso-acessibilidade.vue?vue&type=script&lang=ts&"
export * from "./exibir-recurso-acessibilidade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02d53b8a')) {
      api.createRecord('02d53b8a', component.options)
    } else {
      api.reload('02d53b8a', component.options)
    }
    module.hot.accept("./exibir-recurso-acessibilidade.vue?vue&type=template&id=02d53b8a&", function () {
      api.rerender('02d53b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurso-acessibilidade/exibir-recurso-acessibilidade.vue"
export default component.exports